<div class="app-container">
    <aside class="sidebar">
        <div class="sidebar-header">
            <img src="../../../../../assets/CGL/images/Genpact Icon.png" alt="Genpact Logo" class="logo" width="34"
                height="42" />
        </div>
        <ul class="sidebar-menu">
            <li class="sidebar-item" [class.active]="selectedView === 'playground'" (click)="selectView('playground')">
                <i class="fas fa-comments"></i>
                <span>Playground</span>
            </li>
            <li class="sidebar-item" [class.active]="selectedView === 'deploy'" (click)="selectView('deploy')">
                <i class="fas fa-rocket"></i>
                <span>Deploy</span>
            </li>
        </ul>
        <div class="sidebar-footer">
            <i class="fas fa-tools"></i>
            <span>Settings</span>
            <div class="profile">
                <img src="../../../assets/images/userProfile.png" alt="User Profile" class="profile-img" />
                <span>User</span>
            </div>
        </div>
    </aside>

    <div class="main-content">
        <div *ngIf="selectedView === 'playground'">
            <div class="header">
                <h1 class="gradient-text" style="margin-left:575px;">Agentic Playground</h1>
            </div>
            <div class="fine-tune-model-container" style="background-color:#ffffff00;">

                <div class="code-box">
                    <!-- <div class="devTalk">
        <p class="code-enhance-header">codeGenY Lite improves developer efficiency with a GenAI-powered chat system,
          reducing development time and increasing productivity. It reduces turnaround time by swiftly providing
          resolutions to coding queries.</p>
        <div class="header-links">
          <a class="privacypopup" (click)="openDialog()">Privacy Policy</a>
        </div>
      </div> -->




                    <!-- history -->

                    <!-- history -->


                    <div class="main-container">

                        <!-- History Container -->
                        <div class="history-container" style="margin-left:4px;" [class.open]="isHistoryOpen">
                            <div class="history-header" *ngIf="chatHistoryList?.chat_details?.length > 0">
                                <!-- <span matTooltip="close" (click)="toggleHistory()"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon-xl-heavy max-md:hidden">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M8.85719 3H15.1428C16.2266 2.99999 17.1007 2.99998 17.8086 3.05782C18.5375 3.11737 19.1777 3.24318 19.77 3.54497C20.7108 4.02433 21.4757 4.78924 21.955 5.73005C22.2568 6.32234 22.3826 6.96253 22.4422 7.69138C22.5 8.39925 22.5 9.27339 22.5 10.3572V13.6428C22.5 14.7266 22.5 15.6008 22.4422 16.3086C22.3826 17.0375 22.2568 17.6777 21.955 18.27C21.4757 19.2108 20.7108 19.9757 19.77 20.455C19.1777 20.7568 18.5375 20.8826 17.8086 20.9422C17.1008 21 16.2266 21 15.1428 21H8.85717C7.77339 21 6.89925 21 6.19138 20.9422C5.46253 20.8826 4.82234 20.7568 4.23005 20.455C3.28924 19.9757 2.52433 19.2108 2.04497 18.27C1.74318 17.6777 1.61737 17.0375 1.55782 16.3086C1.49998 15.6007 1.49999 14.7266 1.5 13.6428V10.3572C1.49999 9.27341 1.49998 8.39926 1.55782 7.69138C1.61737 6.96253 1.74318 6.32234 2.04497 5.73005C2.52433 4.78924 3.28924 4.02433 4.23005 3.54497C4.82234 3.24318 5.46253 3.11737 6.19138 3.05782C6.89926 2.99998 7.77341 2.99999 8.85719 3ZM6.35424 5.05118C5.74907 5.10062 5.40138 5.19279 5.13803 5.32698C4.57354 5.6146 4.1146 6.07354 3.82698 6.63803C3.69279 6.90138 3.60062 7.24907 3.55118 7.85424C3.50078 8.47108 3.5 9.26339 3.5 10.4V13.6C3.5 14.7366 3.50078 15.5289 3.55118 16.1458C3.60062 16.7509 3.69279 17.0986 3.82698 17.362C4.1146 17.9265 4.57354 18.3854 5.13803 18.673C5.40138 18.8072 5.74907 18.8994 6.35424 18.9488C6.97108 18.9992 7.76339 19 8.9 19H9.5V5H8.9C7.76339 5 6.97108 5.00078 6.35424 5.05118ZM11.5 5V19H15.1C16.2366 19 17.0289 18.9992 17.6458 18.9488C18.2509 18.8994 18.5986 18.8072 18.862 18.673C19.4265 18.3854 19.8854 17.9265 20.173 17.362C20.3072 17.0986 20.3994 16.7509 20.4488 16.1458C20.4992 15.5289 20.5 14.7366 20.5 13.6V10.4C20.5 9.26339 20.4992 8.47108 20.4488 7.85424C20.3994 7.24907 20.3072 6.90138 20.173 6.63803C19.8854 6.07354 19.4265 5.6146 18.862 5.32698C18.5986 5.19279 18.2509 5.10062 17.6458 5.05118C17.0289 5.00078 16.2366 5 15.1 5H11.5ZM5 8.5C5 7.94772 5.44772 7.5 6 7.5H7C7.55229 7.5 8 7.94772 8 8.5C8 9.05229 7.55229 9.5 7 9.5H6C5.44772 9.5 5 9.05229 5 8.5ZM5 12C5 11.4477 5.44772 11 6 11H7C7.55229 11 8 11.4477 8 12C8 12.5523 7.55229 13 7 13H6C5.44772 13 5 12.5523 5 12Z" 
        fill="currentColor"></path>
      </svg>
    </span> -->
                                <h4 style="font-size: 18px;">Sessions</h4>





                                <!-- <span matTooltip="start new conversation" (click)="newChat()">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"
                                    xmlns="http://www.w3.org/2000/svg" class="icon-xl-heavy">
                                    <path
                                        d="M15.6729 3.91287C16.8918 2.69392 18.8682 2.69392 20.0871 3.91287C21.3061 5.13182 21.3061 7.10813 20.0871 8.32708L14.1499 14.2643C13.3849 15.0293 12.3925 15.5255 11.3215 15.6785L9.14142 15.9899C8.82983 16.0344 8.51546 15.9297 8.29289 15.7071C8.07033 15.4845 7.96554 15.1701 8.01005 14.8586L8.32149 12.6785C8.47449 11.6075 8.97072 10.615 9.7357 9.85006L15.6729 3.91287ZM18.6729 5.32708C18.235 4.88918 17.525 4.88918 17.0871 5.32708L11.1499 11.2643C10.6909 11.7233 10.3932 12.3187 10.3014 12.9613L10.1785 13.8215L11.0386 13.6986C11.6812 13.6068 12.2767 13.3091 12.7357 12.8501L18.6729 6.91287C19.1108 6.47497 19.1108 5.76499 18.6729 5.32708ZM11 3.99929C11.0004 4.55157 10.5531 4.99963 10.0008 5.00007C9.00227 5.00084 8.29769 5.00827 7.74651 5.06064C7.20685 5.11191 6.88488 5.20117 6.63803 5.32695C6.07354 5.61457 5.6146 6.07351 5.32698 6.63799C5.19279 6.90135 5.10062 7.24904 5.05118 7.8542C5.00078 8.47105 5 9.26336 5 10.4V13.6C5 14.7366 5.00078 15.5289 5.05118 16.1457C5.10062 16.7509 5.19279 17.0986 5.32698 17.3619C5.6146 17.9264 6.07354 18.3854 6.63803 18.673C6.90138 18.8072 7.24907 18.8993 7.85424 18.9488C8.47108 18.9992 9.26339 19 10.4 19H13.6C14.7366 19 15.5289 18.9992 16.1458 18.9488C16.7509 18.8993 17.0986 18.8072 17.362 18.673C17.9265 18.3854 18.3854 17.9264 18.673 17.3619C18.7988 17.1151 18.8881 16.7931 18.9393 16.2535C18.9917 15.7023 18.9991 14.9977 18.9999 13.9992C19.0003 13.4469 19.4484 12.9995 20.0007 13C20.553 13.0004 21.0003 13.4485 20.9999 14.0007C20.9991 14.9789 20.9932 15.7808 20.9304 16.4426C20.8664 17.116 20.7385 17.7136 20.455 18.2699C19.9757 19.2107 19.2108 19.9756 18.27 20.455C17.6777 20.7568 17.0375 20.8826 16.3086 20.9421C15.6008 21 14.7266 21 13.6428 21H10.3572C9.27339 21 8.39925 21 7.69138 20.9421C6.96253 20.8826 6.32234 20.7568 5.73005 20.455C4.78924 19.9756 4.02433 19.2107 3.54497 18.2699C3.24318 17.6776 3.11737 17.0374 3.05782 16.3086C2.99998 15.6007 2.99999 14.7266 3 13.6428V10.3572C2.99999 9.27337 2.99998 8.39922 3.05782 7.69134C3.11737 6.96249 3.24318 6.3223 3.54497 5.73001C4.02433 4.7892 4.78924 4.0243 5.73005 3.54493C6.28633 3.26149 6.88399 3.13358 7.55735 3.06961C8.21919 3.00673 9.02103 3.00083 9.99922 3.00007C10.5515 2.99964 10.9996 3.447 11 3.99929Z"
                                        fill="currentColor"></path>
                                </svg>


                            </span> -->

                            </div>
                            <div class="session-actions" *ngIf="chatHistoryList?.chat_details?.length > 0">
                                <button (click)="openSessionModal()" class="btn-create-session">
                                    <i class="fas fa-plus"></i> &nbsp;&nbsp; New Session
                                </button>
                            </div>


                            <!-- <div class="history-header">
      <h4>Conversations</h4>  
    </div> -->
                            <div class="history-content">

                                <!-- Skeleton Loader -->
                                <!-- Skeleton Loader -->
                                <!-- Skeleton Loader -->
                                <div *ngIf="isLoading" class="skeleton-wrapper">
                                    <div class="skeleton-title"></div>
                                    <ul>
                                        <li
                                            *ngFor="let item of [].constructor(chatHistoryList?.chat_details?.length || 20)">
                                            <div class="skeleton-item"></div>
                                        </li>
                                    </ul>
                                </div>

                                <div *ngIf="!isLoading">

                                    <!-- Grouped Histories -->
                                    <div *ngIf="chatHistoryList?.chat_details?.length <= 0"
                                        class="no-conversations-container">
                                        <div class="no-conversations-content">
                                            <img src="assets/CGL/images/stars.png" alt="No Conversations Icon"
                                                class="no-conversations-icon" />

                                            <h3 class="no-conversations-title">
                                                No Sessions Created Yet
                                            </h3>
                                            <p class="no-conversations-text">
                                                Start a Session by selecting an existing endpoint or by clicking on the
                                                New
                                                Session
                                            </p>

                                            <div class="session-actions">
                                                <button (click)="openSessionModal()" class="btn-create-session">
                                                    <i class="fas fa-plus"></i> &nbsp;&nbsp; New Session
                                                </button>
                                            </div>

                                        </div>
                                    </div>


                                    <div *ngFor="let group of groupedHistories | keyvalue : sortGroups"
                                        class="history-group">
                                        <h3>{{ group.key }}</h3>
                                        <ul>
                                            <li *ngFor="let chat of group.value"
                                                [class.active]="chat.chat_id === active_chatId"
                                                (click)="loadChat(chat.chat_id,chat);">
                                                <div class="chat-item-content">
                                                    <span class="chat-title" title="{{ chat.title || 'No Title' }}">
                                                        {{ chat.title || 'No Title' }}
                                                    </span>

                                                    <!-- Action Buttons -->
                                                    <div class="chat-actions">
                                                        <button
                                                            (click)="openModal(confirm_model,chat.chat_id,$event); $event.stopPropagation();"
                                                            class="delete-btn" title="Delete Chat">
                                                            <!-- Delete Icon -->
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="16"
                                                                height="16" fill="currentColor" class="bi bi-trash"
                                                                viewBox="0 0 16 16">
                                                                <path
                                                                    d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                                                                <path
                                                                    d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                                                            </svg>
                                                        </button>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>


                                </div>



                            </div>
                        </div>


                        <div class="devTalk" [class.history-open]="isHistoryOpen">
                            <div class="row gx-1 gy-1">
                                <div class="col">
                                    <button *ngIf="!this.isHistoryOpen" class="history-toggle-btn"
                                        (click)="toggleHistory()">
                                        <!-- History Icon -->
                                        <span _ngcontent-ng-c3490356044="" class="icon"><svg
                                                _ngcontent-ng-c3490356044="" xmlns="http://www.w3.org/2000/svg"
                                                width="28" height="28" viewBox="0 0 24 24">
                                                <path _ngcontent-ng-c3490356044="" fill="currentColor"
                                                    d="M13 3a9 9 0 0 0-9 9H1l3.89 3.89l.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7s-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42A8.954 8.954 0 0 0 13 21a9 9 0 0 0 0-18m-1 5v5l4.28 2.54l.72-1.21l-3.5-2.08V8z">
                                                </path>
                                            </svg></span>
                                        <span>History</span>
                                    </button>

                                    <!-- Sidenav -->
                                    <!-- <nav id="sidenav-1" data-mdb-sidenav-init class="sidenav" data-mdb-hidden="false">
    <ul class="sidenav-menu">
      <li class="sidenav-item">
        <a class="sidenav-link">
          <i class="far fa-smile fa-fw me-3"></i><span>Link 1</span></a>
      </li>
      <li class="sidenav-item">
        <a class="sidenav-link"><i class="fas fa-grin fa-fw me-3"></i><span>Category 1</span></a>
        <ul class="sidenav-collapse show">
          <li class="sidenav-item">
            <a class="sidenav-link">Link 2</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link">Link 3</a>
          </li>
        </ul>
      </li>
      <li class="sidenav-item">
        <a class="sidenav-link"><i class="fas fa-grin-wink fa-fw me-3"></i><span>Category
            2</span></a>
        <ul class="sidenav-collapse">
          <li class="sidenav-item">
            <a class="sidenav-link">Link 4</a>
          </li>
          <li class="sidenav-item">
            <a class="sidenav-link">Link 5</a>
          </li>
        </ul>
      </li>
    </ul>
  </nav> -->
                                    <!-- Sidenav -->
                                    <!-- <button style="background-color: #ffffff;color:#FF4F59" data-mdb-button-init data-mdb-toggle="sidenav" data-mdb-target="#sidenav-1"
            data-mdb-ripple-init class="btn btn-primary" aria-controls="#sidenav-1" aria-haspopup="true">
            <i class="fas fa-bars"></i>
          </button> -->

                                    <div class="chat-section">
                                        <div *ngIf="!ischat" class="chat-container">
                                            <div class="chat-header">
                                                <i class="fas fa-comment-dots" style="    font-size: 175px;
                                                color: #ff4f59;
                                                margin-left: 345px;"></i>
                                                <h1>Start a New Task</h1>
                                            </div>
                                            <div class="chat-body">
                                                <p class="subtitle">Enter a task to get started</p>
                                                <!-- <p class="description">
                    Improve developer efficiency with instant, AI-powered chat support, 
                    minimizing downtime and increasing productivity. 
                    Cut operational costs by providing quick resolutions to coding queries.
                  </p> -->

                                                <!-- Button container with prompts -->
                                                <!-- <div class="button-container"> -->
                                                <!-- Display categories in the main view -->
                                                <!-- <ng-container *ngFor="let category of promptCategories"> -->
                                                <!-- Exclude 'Project Managers' category if present -->
                                                <!-- <ng-container *ngIf="category.category !== 'Project Managers'">
                                                        <button (click)="selectCategory(category); showMorePrompts()"
                                                            class="btn">
                                                            {{ category.category }}
                                                        </button>
                                                    </ng-container>
                                                </ng-container>
                                            </div> -->

                                                <!-- Modal for displaying prompts under the selected category -->
                                                <div *ngIf="viewMore" class="modal d-flex " style="padding-top: 1px;">
                                                    <div class="modal-content">
                                                        <!-- Close button on the extreme right -->
                                                        <span class="close" (click)="showMorePrompts()">&times;</span>

                                                        <!-- Conditional header based on selected category -->
                                                        <h2 class="modal-header">
                                                            {{ selectedCategory ? selectedCategory.category + ' Prompts'
                                                            :
                                                            'Select a
                                                            Category' }}
                                                        </h2>

                                                        <!-- Back button to go back to category selection -->
                                                        <!-- <button *ngIf="selectedCategory" (click)="backToCategories()" class="btn back-btn">  
                      &larr; Back to Categories  
                    </button>   -->

                                                        <!-- Container for prompts under the selected category -->
                                                        <div *ngIf="selectedCategory" class="modal-button-container">
                                                            <div class="category-prompts">
                                                                <button *ngFor="let prompt of selectedCategory.prompts"
                                                                    (click)="setUserMessage(prompt); showMorePrompts();"
                                                                    class="btn">
                                                                    {{ prompt }}
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>


                                        <div *ngIf="ischat" class="chat-window" #ChatWindow>
                                            <div class="message">
                                                <div class="user-message">
                                                    <!-- <div class="profile-icon">
                      <img src="../../../assets/images/aiProfile.png" alt="">
                    </div> -->








                                                    <!-- <div class="message-content" style="background: #fff;"> -->
                                                    <!-- <div class="message-text" style="color: #212529; letter-spacing: 1.2px;">Hello and welcome! I am
                        your personal Coding AI Assistant, codeGenY Lite, your Infinite Subject Matter Expert, ready to
                        assist you across all subject areas and design principles for coding. You can refer to me as
                        'codeGenY Lite' throughout our interaction. My primary mission is to craft top-notch software
                        solutions. As an expert in programming, security, documentation, and a follower of industry
                        best practices, including SOLID and DRY principles, I will diligently work on your software
                        project. I'll be sure to ask questions to gain a complete understanding of your specifications
                        before I engineer the software. No need for you to provide code – I'm here to assist you in
                        every step.</div> -->
                                                    <!-- </div> -->
                                                </div>
                                            </div>
                                            <!-- Messages Loop -->
                                            <div *ngFor="let message of chatMessages;let i = index" class="message"
                                                [ngClass]="{'user': message.type === 'user', 'bot': message.type === 'bot'}">
                                                <!-- User Message -->
                                                <div *ngIf="message.type === 'user'" class="user-message">
                                                    <div class="profile-icon">
                                                        <img src="../../../assets/images/userProfile.png" alt="">
                                                    </div>

                                                    <div class="message-content">
                                                        <div *ngIf="message.file" class="file-content">
                                                            <div class="file-text">File name:{{ message.file }}</div>

                                                        </div>

                                                        <!-- <div class="message-text">{{ message.userMessage }}</div> -->

                                                        <div class="message-text" *ngIf="message.userMessage">{{
                                                            message.userMessage
                                                            }}</div>
                                                        <div class="message-text" *ngIf="!message.userMessage">{{
                                                            message.message }}
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- Bot Message -->
                                                <div *ngIf="message.type === 'bot'" class="bot-message">
                                                    <div class="profile-icon">
                                                        <img src="../../../assets/images/aiProfile.png" alt="">
                                                    </div>
                                                    <div class="message-content">
                                                        <div markdown lineNumbers clipboard [data]="message.message "
                                                            [disableSanitizer]="true" class="message-text"></div>


                                                        <ng-container *ngIf="message?.message">
                                                            <div class="user-action" *ngIf="message.type != 'user'">
                                                                <div [hidden]="isCopied" class="btn btn-sm"
                                                                    (click)="copyToClipboard(message?.message)"
                                                                    title="Copy to clipboard">

                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21"
                                                                        fill="none" viewBox="0 0 24 24"
                                                                        class="icon-md-heavy">
                                                                        <path fill="#474747" fill-rule="evenodd"
                                                                            d="M7 5a3 3 0 0 1 3-3h9a3 3 0 0 1 3 3v9a3 3 0 0 1-3 3h-2v2a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3v-9a3 3 0 0 1 3-3h2zm2 2h5a3 3 0 0 1 3 3v5h2a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-9a1 1 0 0 0-1 1zM5 9a1 1 0 0 0-1 1v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1z"
                                                                            clip-rule="evenodd" />
                                                                    </svg>
                                                                </div>
                                                                <div [hidden]="!isCopied" class="btn btn-sm">
                                                                    <svg xmlns="http://www.w3.org/2000/svg" width="21"
                                                                        fill="none" viewBox="0 0 24 24"
                                                                        class="icon-md-heavy">
                                                                        <path fill="#474747" fill-rule="evenodd"
                                                                            d="M18.063 5.674a1 1 0 0 1 .263 1.39l-7.5 11a1 1 0 0 1-1.533.143l-4.5-4.5a1 1 0 1 1 1.414-1.414l3.647 3.647 6.82-10.003a1 1 0 0 1 1.39-.263"
                                                                            clip-rule="evenodd" />
                                                                    </svg>
                                                                </div>
                                                                <div class="btn btn-sm" (click)="regenerate(i)"
                                                                    title="Regenerate">
                                                                    <svg xmlns="http://www.w3.org/2000/svg"
                                                                        width="15.984" height="16.004"
                                                                        viewBox="0 0 15.984 16.004">
                                                                        <path id="ic--round-refresh"
                                                                            d="M17.65,6.35a7.95,7.95,0,0,0-6.48-2.31,8,8,0,1,0,8.04,11.4,1,1,0,0,0-.9-1.44.973.973,0,0,0-.88.53A5.993,5.993,0,1,1,12,6a5.915,5.915,0,0,1,4.22,1.78L14.71,9.29a1,1,0,0,0,.7,1.71H19a1,1,0,0,0,1-1V6.41a1,1,0,0,0-1.71-.71Z"
                                                                            transform="translate(-4.016 -3.996)"
                                                                            fill="#474747" />
                                                                    </svg>

                                                                </div>
                                                                <!-- <div class="btn btn-sm" (click)="generateDocument(message?.message)"  title="Download">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-download" viewBox="0 0 16 16">
                          <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5"/>
                          <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708z"/>
                        </svg>
    
                    </div> -->




                                                            </div>
                                                        </ng-container>

                                                    </div>
                                                </div>




                                            </div>
                                        </div>
                                        <!-- Message Input Area -->
                                        <!-- <div class="input-area">
                <textarea [disabled]="showCustomLoader" #textarea id="textarea" class="form-control custom-control" (input)="adjustTextareaHeight($event)"
                  [(ngModel)]="userMessage" (keydown.enter)="sendMessage($event)" placeholder="Type your message here..."
                  style="resize: vertical;"
                ></textarea>
                <button class="chat-btn" (click)="sendMessage()">
                  <img *ngIf="!showCustomLoader; else loaderTemplate" src="../../../../assets/CGL/images/send.png" alt="Send">
                  <ng-template #loaderTemplate>
                    <div class="loader">
                      <div class="dots"></div>
                    </div>
                  </ng-template>
                </button>
                
               
              </div> -->
                                        <!-- Validation Messages -->
                                        <div>

                                        </div>
                                        <small class="text-danger" *ngIf="messageFormControl.hasError('minlength')">
                                            Message must be at least 2 characters long.
                                        </small>
                                        <small class="text-danger" *ngIf="messageFormControl.hasError('maxlength')">
                                            Message cannot exceed 40000 characters.
                                        </small>
                                    </div>

                                </div>





                            </div>

                            <div class="chat-section1" style="background-color: #ffffff;">



                                <div class="input-container">
                                    <!-- File Preview Section -->
                                    <div class="file-preview-wrapper" *ngIf="uploadedFiles.length > 0">
                                        <div class="file-item" *ngFor="let file of uploadedFiles; let i = index">
                                            <!-- File Type Icon -->


                                            <!-- File Name -->
                                            <span class="file-name">{{ file.name }}</span>

                                            <!-- Remove Button -->
                                            <button style="background-color:transparent ; color:#ff555f;"
                                                (click)="removeFile(i)">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                    fill="currentColor" class="bi bi-x" viewBox="0 0 16 16">
                                                    <path
                                                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                                                </svg>
                                            </button>
                                        </div>
                                    </div>



                                    <!-- Input & Buttons Section -->
                                    <div class="input-wrapper" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
                                        <!-- Left Buttons -->
                                        <div class="left-buttons">
                                            <!-- Attach File -->
                                            <label [title]="extension" for="fileInput" class="icon-btn">
                                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20"
                                                    fill="currentColor" class="bi bi-paperclip" viewBox="0 0 16 16">
                                                    <path
                                                        d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0z" />
                                                </svg>
                                            </label>
                                            <input [accept]="allowedFileTypes1" type="file" id="fileInput" #fileInput
                                                (change)="handleFileUpload($event)" hidden />

                                            <!-- New Chat -->
                                            <div class="new-topic" (click)="newChat()">
                                                <span matTooltip="New Chat" popoverClass="pop-block"
                                                    triggers="mouseenter:mouseleave">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                        viewBox="0 0 24 24" fill="none">
                                                        <path
                                                            d="M12 4C8.229 4 6.343 4 5.172 5.172C4.001 6.344 4 8.229 4 12V18C4 18.943 4 19.414 4.293 19.707C4.586 20 5.057 20 6 20H12C15.771 20 17.657 20 18.828 18.828C19.999 17.656 20 15.771 20 12"
                                                            stroke="#102345" stroke-width="2" />
                                                        <path d="M9 10H15M9 14H12M19 8V2M16 5H22" stroke="#102345"
                                                            stroke-width="2" stroke-linecap="round"
                                                            stroke-linejoin="round" />
                                                    </svg>
                                                </span>

                                            </div>
                                        </div>

                                        <!-- Textarea -->
                                        <div class="textarea-container">
                                            <textarea [(ngModel)]="userMessage" placeholder="Type your message here..."
                                                (input)="adjustTextareaHeight($event)" (keydown.enter)="sendMessage()"
                                                rows="1"></textarea>
                                        </div>

                                        <!-- Send Button -->
                                        <button class="send-btn" (click)="sendMessage()" *ngIf="!showCustomLoader">
                                            <img src="../../../../../assets/CGL/images/send.png" alt="Send">
                                        </button>
                                        <button class="send-btn" (click)="stopGenerating()" *ngIf="showCustomLoader">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                                fill="#ff555f" class="bi bi-stop-circle" viewBox="0 0 16 16">
                                                <path
                                                    d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" />
                                                <path
                                                    d="M5 6.5A1.5 1.5 0 0 1 6.5 5h3A1.5 1.5 0 0 1 11 6.5v3A1.5 1.5 0 0 1 9.5 11h-3A1.5 1.5 0 0 1 5 9.5z" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>







                            </div>

                        </div>
                    </div>
                </div>
                <!-- Privacy Policy Dialog -->
            </div>
        </div>

        <div *ngIf="selectedView === 'deploy'" class="deploy-content">



            <body>
                <div class="header">
                    <h1 class="gradient-text">Agentic Playground</h1>
                </div>

                <div class="content">
                    <h2>Deploy</h2>
                    <div  *ngFor="let endpoint of options" class="tabs">
                    
                        <div class="tab">{{endpoint}}</div>
                    </div>
                  <div class="section" style="display:none">
                        <h3>Using AutoGen Studio Teams in Python Code and REST API</h3>
                        <p>Prerequisites</p>
                        <div style="background-color: #e9f7ff; padding: 10px; border-radius: 5px; margin-bottom: 10px;">
                            <ul>
                                <li>AutoGen Studio installed</li>
                            </ul>
                        </div>
                        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Integer nec odio. Praesent libero.
                            Sed cursus ante dapibus diam. Sed nisi.</p>
                    </div> 
                    <div class="section" style="display:none">
                        <h3>1. Run a Team in Python</h3>
                        <p>Here's a simple example of using the TeamManager class from AutoGen Studio in your python
                            code.</p>
                        <div class="code-block">
                            <div class="copy">Copy</div>
                            <code>
from autogenstudio.teammanager import TeamManager

# Initialize the TeamManager
manager = TeamManager()

# Run a task with a specific team configuration
result = await manager.run(
    task="What is the weather in New York?",
    team_config="team.json"
)
                </code>
                        </div>
                    </div>
                </div>
            </body>
        </div>



    </div>
</div>

<!-- <br><br>  -->
<div class="chat-window" #ChatWindow1>

</div>
<!--  <br><br>  <br><br>  <br><br>   -->

<!-- Your Angular components and scripts here -->
<!-- <div *ngIf="showCustomLoader" class="overlay">
      <div class="spinner"></div>
    </div> -->
<ng-template #confirm_model>

    <div class="modal-body text-center">
        <button type="button" class="close" (click)="modalRef?.hide()">&times;</button>

        <p>Are you sure you want to delete this chat?</p>
        <button style="border-radius: 0px; border:none;" type="button" class="btn btn-default "
            (click)="deleteChat(this.histroyDeleteId,this.deleteid);modalRef?.hide()">Yes</button>
        <button style="border-radius: 0px;border:none;" type="button" class="btn btn-primary"
            (click)="modalRef?.hide()">No</button>
    </div>
</ng-template>

<div *ngIf="isspinner" class="overlay">
    <div class="spinner"></div>
</div>

<ng-template #sessionModal let-modal>
    <div class="modal-backdrop">
        <div class="modal-content">
            <span class="close" (click)="modal.close()">&times;</span>
            <h2>Create A New Session</h2>
            <form (ngSubmit)="submitSessionForm()">
                <div class="form-group">
                    <label for="sessionName">Session Name <span class="required">*</span></label>
                    <input type="text" id="sessionName" [(ngModel)]="sessionName" name="sessionName" required>
                </div>
                <div class="form-group">
                    <label for="endpoint">Select Endpoint</label>
                    <select id="endpoint" [(ngModel)]="selectedEndpoint" name="endpoint" required>
                        <option value="" disabled>Select an option</option>
                        <option *ngFor="let endpoint of endpoints" [value]="endpoint">{{ endpoint }}</option>
                    </select>
                </div>
                <button type="submit" class="btn-submit">Submit</button>
            </form>
        </div>
    </div>
</ng-template>